var _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Location") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Iconos"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,54.71h0a16.55,16.55,0,0,0,11.75-5A16.53,16.53,0,0,0,50,21.67h-.1a16.53,16.53,0,0,0-11.8,5,16.16,16.16,0,0,0-4.68,11.59A16.5,16.5,0,0,0,50,54.71ZM40.2,28.77a13.54,13.54,0,0,1,9.68-4.1H50A13.42,13.42,0,0,1,63.44,38.12a13.26,13.26,0,0,1-3.84,9.51A13.46,13.46,0,0,1,50,51.71h0A13.52,13.52,0,0,1,36.38,38.22,13.14,13.14,0,0,1,40.2,28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.06,55.08l.06.11q7.44,13.19,14.93,26.33l.65,1.15c1.06,1.86,2.15,3.79,3.33,5.63a5.65,5.65,0,0,0,4.78,2.58h0a5.82,5.82,0,0,0,4.92-2.68c.31-.47.58-1,.86-1.45l4.83-8.51Q68,64.88,75.61,51.51A26,26,0,0,0,79,39.12,27.51,27.51,0,0,0,77,27.86c-4.58-11-12.89-17.25-24.69-18.59a27,27,0,0,0-11,1.19,27.85,27.85,0,0,0-13.59,9.1A29.2,29.2,0,0,0,21,37.33v0a31.32,31.32,0,0,0,1.44,10A42.23,42.23,0,0,0,26.06,55.08ZM30,21.45a25,25,0,0,1,12.16-8.13,23.48,23.48,0,0,1,9.78-1.06C62.58,13.46,70.07,19.09,74.2,29a24.5,24.5,0,0,1,1.84,10,23.08,23.08,0,0,1-3,11Q65.43,63.4,57.82,76.75L53,85.27c-.25.45-.5.89-.77,1.32a2.88,2.88,0,0,1-2.4,1.29h0a2.6,2.6,0,0,1-2.25-1.2c-1.14-1.77-2.21-3.66-3.25-5.49L43.66,80Q36.19,66.88,28.73,53.71l-.06-.1a39.55,39.55,0,0,1-3.43-7.14A28.36,28.36,0,0,1,24,37.37,26.28,26.28,0,0,1,30,21.45Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 115,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "Created by Fran Couto")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 120,
    fill: "#000000",
    fontSize: "5px",
    fontWeight: "bold",
    fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
  }, "from the Noun Project")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.75af3c9b3495c41b5dfd61638a33d69d.svg";
export { ForwardRef as ReactComponent };